import blur from 'common/utils/blur';
import { isUndefinedOrNullOrEmpty } from 'common/utils/isUndefinedOrNullOrEmpty';

class InputDatepickerController {
  constructor($scope, EventEmitter, $timeout) {
    'ngInject';
    this.scope = $scope;
    this.EventEmitter = EventEmitter;
    const format = 'dd/MM/yyyy';
    this.format = format;
    this.altInputFormats = [format];
    this.options = this.getDefaultOptions();
    this.dateModel = null;
    this.initDate = null;
    this.timeout = $timeout;
  }

  $onInit() {
    this.setMinDateInMobile();
    this.emitDateOnChange();
    this.assignInitialDate();    

    this.scope.$watch(() => this.initDate, initDate => {
      this.setInitDate(initDate);
    });

    this.scope.$watch(() => this.startDate, () => {
      this.assignInitialDate();
    });
  }

  setMinDateInMobile() {
    if(this.isMobileApp) {
      this.scope.$watch(() => this.minDate,() => {
        this.minDateMobile = this.minDate;
      });  
    }
  }

  emitDateOnChange() {
    this.scope.$watch(() => this.dateModel, (newValue) => {
      if (!this.isDate(newValue)) {
        return;
      }

      this.onDatepick(this.EventEmitter({date: newValue}));

      blur(this.timeout);
    });
  }

  isInputRequired() {
    if (isUndefinedOrNullOrEmpty(this.isRequired)) {
      return true;
    }
    return this.isRequired;
  }

  assignInitialDate() {
    if (this.startDate) {
      this.dateModel = this.startDate;
    }
  }

  getDefaultOptions() {
    const me = this;
    return {
      startingDay: 1,
      showWeeks: false,
      minMode: 'day',
      maxMode: 'day',
      dateDisabled: ({date, mode}) => this.dateDisabled.apply(me, [date, mode]),
    };
  }

  setInitDate(initDate) {
    if(initDate)
      this.options.initDate = new Date(initDate.getTime());
  }

  dateDisabled() {
    const selectedDate = arguments[0];

    if (this.disableBeforeStartDate) {
      const beforeStartDay = selectedDate <= this.startDate;
      return beforeStartDay;
    }

    return false;
  }

  isDate(date) {
    return Object.prototype.toString.call(date) === '[object Date]';
  }

  openMobile($event) {
    const currentTarget = $event.currentTarget;
    const wrapper = currentTarget.parentElement;
    const input = $(wrapper).find('input');
    $(input).focus();
  }
}

export default InputDatepickerController;



// WEBPACK FOOTER //
// ./client/app/components/inputDatepicker/inputDatepicker.controller.js